const getIndustry = (category, subCategory, list) => {
    if (!list || !category || !subCategory) return '-';
    const area =  list[category] || {};
    const sub = area?.sub || {};
    const areaDetail = sub[subCategory] || {};
    if (!area.name || !areaDetail.name) return '-';
    return `${area.name} / ${areaDetail.name}`;
};
const getAddress = (data, list, extra) => {
    if (!list || !data || !list.length) return extra || '-';
    const province = list.find(item => item.value == data.province) || {};
    const city = province.children?.find(item => item.value == data.city) || {};
    if (!province.text || !city.text) return extra || '-';
    return `${province.text} ${city.text} ${extra || ''}`;
};
export {
    getIndustry,
    getAddress,
};
